import React, { useEffect } from 'react'

import { Col } from 'react-bootstrap'

import checkIdExists from '../../utils/check-id-exists'
import Spinner from '../spinner/spinner'
import CandidateCard from '../candidate-card/candidate-card'

const ListOfSearch = ({ bulkProcessing, searchLoading, setProcessing, listOfSearch, processing, shortlist, cart, setList, selected }) => {
    useEffect(() => {
    }, [listOfSearch])
    if (searchLoading) {
        return <Spinner />
    }
    return (
        !bulkProcessing &&
        listOfSearch.length > 0 &&
        listOfSearch.map(candidate => (
            <Col key={candidate.id} lg={12}>
                <CandidateCard
                    candidate={candidate}
                    loading={processing}
                    setLoading={setProcessing}
                    shortlist={shortlist}
                    cart={cart}
                    page="search"
                    setList={setList}
                    selected={checkIdExists(
                        selected,
                        candidate.candidate.id
                    )}
                    displayCartButton={true}  // is true by default but better to pass true to increase readability
                    displayShortlistButton={true}
                />
            </Col>
        )
        )
    )
}


export default ListOfSearch